import MyDocument1 from "./components/PDFFormats/myDocument1";
import MyDocument2 from "./components/PDFFormats/myDocument2";
import MyDocument3 from "./components/PDFFormats/myDocument3";
import MyDocument4 from "./components/PDFFormats/myDocument4";
import MyDocument5 from "./components/PDFFormats/myDocument5";
import MyDocument6 from "./components/PDFFormats/myDocument6";
import MyDocument7 from "./components/PDFFormats/myDocument7";
import MyDocument8 from "./components/PDFFormats/myDocument8";
import MyDocument9 from "./components/PDFFormats/myDocument9";
import MyDocument10 from "./components/PDFFormats/myDocument10";
import MyDocument11 from "./components/PDFFormats/myDocument11";
import MyDocument12 from "./components/PDFFormats/myDocument12";
import MyDocument13 from "./components/PDFFormats/myDocument13";
import MyDocument14 from "./components/PDFFormats/myDocument14";
import MyDocument15 from "./components/PDFFormats/myDocument15";
import MyDocument16 from "./components/PDFFormats/myDocument16";
import MyDocument17 from "./components/PDFFormats/myDocument17";
import MyDocument18 from "./components/PDFFormats/myDocument18";
import MyDocument19 from "./components/PDFFormats/myDocument19";
import MyDocument20 from "./components/PDFFormats/myDocument20";
import MyDocument21 from "./components/PDFFormats/myDocument21";
import MyDocument22 from "./components/PDFFormats/myDocument22";
import MyDocument23 from "./components/PDFFormats/myDocument23";
import MyDocument24 from "./components/PDFFormats/myDocument24";
import MyDocument25 from "./components/PDFFormats/myDocument25";
import MyDocument26 from "./components/PDFFormats/myDocument26";
import MyDocument27 from "./components/PDFFormats/myDocument27";
import MyDocument28 from "./components/PDFFormats/myDocument28";
import MyDocument29 from "./components/PDFFormats/myDocument29";
import MyDocument30 from "./components/PDFFormats/myDocument30";
import MyDocument31 from "./components/PDFFormats/myDocument31";
import MyDocument32 from "./components/PDFFormats/myDocument32";
import MyDocument33 from "./components/PDFFormats/myDocument33";
import MyDocument34 from "./components/PDFFormats/myDocument34";

export const handlePdfDocument = (arabChunks, engChunks, resultPdfId) => {
  let document, resultsFilters;
  switch (resultPdfId) {
    case 1: {
      document = <MyDocument1 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
      ];
      break;
    }
    case 2: {
      document = <MyDocument2 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
      ];
      break;
    }
    case 3: {
      document = <MyDocument3 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeperate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
      ];
      break;
    }
    case 4: {
      document = <MyDocument4 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 5: {
      document = <MyDocument5 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 6: {
      document = <MyDocument6 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 7: {
      document = <MyDocument7 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
      ];
      break;
    }
    case 8: {
      document = <MyDocument8 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
      ];
      break;
    }
    case 9: {
      document = <MyDocument9 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 10: {
      document = <MyDocument10 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 11: {
      document = <MyDocument11 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 12: {
      document = <MyDocument12 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 13: {
      document = <MyDocument13 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/flip_vertical.svg",
          engTitle: "\nFlip Vertical",
          arabTitle: "عكس عامودي",
        },
        {
          icon: "/icons/cross.svg",
          name: "Cross",
          engTitle: "\nCross",
          arabTitle: "نصوص عابرة",
        },
      ];
      break;
    }
    case 14: {
      document = <MyDocument14 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/flip_vertical.svg",
          engTitle: "\nFlip Vertical",
          arabTitle: "عكس عامودي",
        },
        {
          icon: "/icons/cross.svg",
          engTitle: "\nCross",
          arabTitle: "نصوص عابرة",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
      ];
      break;
    }
    case 15: {
      document = <MyDocument15 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/flip_vertical.svg",
          engTitle: "\nFlip Vertical",
          arabTitle: "عكس عامودي",
        },
        {
          icon: "/icons/cross.svg",
          engTitle: "\nCross",
          arabTitle: "نصوص عابرة",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
      ];
      break;
    }
    case 16: {
      document = <MyDocument16 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_180.svg",
          engTitle: "\nRotate 180",
          arabTitle: "تدوير 180",
        },
      ];
      break;
    }
    case 17: {
      document = <MyDocument17 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/flip_vertical.svg",
          engTitle: "\nFlip Vertical",
          arabTitle: "عكس عامودي",
        },
        {
          icon: "/icons/arabic-icon.svg",
          engTitle: "\nArabic Priority",
          arabTitle: "الأولوية للعربي",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 18: {
      document = <MyDocument18 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/flip_vertical.svg",
          engTitle: "\nFlip Vertical",
          arabTitle: "عكس عامودي",
        },
        {
          icon: "/icons/latin-icon.svg",
          engTitle: "\nLatin Priority",
          arabTitle: "الأولوية لللاتيني",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 19: {
      document = <MyDocument19 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
        {
          icon: "/icons/arabic-icon.svg",
          engTitle: "\nArabic Priority",
          arabTitle: "الأولوية للعربي",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 20: {
      document = <MyDocument20 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/rotate_90.svg",
          engTitle: "\nRotate 90",
          arabTitle: "تدوير 90",
        },
        {
          icon: "/icons/latin-icon.svg",
          engTitle: "\nLatin Priority",
          arabTitle: "الأولوية لللاتيني",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 21: {
      document = <MyDocument21 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_180.svg",
          engTitle: "\nRotate 180",
          arabTitle: "تدوير 180",
        },
        {
          icon: "/icons/arabic-icon.svg",
          engTitle: "\nArabic Priority",
          arabTitle: "الأولوية للعربي",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 22: {
      document = <MyDocument22 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/rotate_180.svg",
          engTitle: "\nRotate 180",
          arabTitle: "تدوير 180",
        },
        {
          icon: "/icons/latin-icon.svg",
          engTitle: "\nLatin Priority",
          arabTitle: "الأولوية لللاتيني",
        },
        {
          icon: "/icons/structure_icon_02.svg",
          engTitle: "\nBook in Book",
          arabTitle: "كتاب في كتاب",
        },
      ];
      break;
    }
    case 23: {
      document = <MyDocument23 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/flip_horizontal.svg",
          engTitle: "\nFlip Horizontal",
          arabTitle: "عكس أفقي",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 24: {
      document = <MyDocument24 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/rotate_180.svg",
          engTitle: "\nRotate 180",
          arabTitle: "تدوير 180",
        },
        {
          icon: "/icons/arabic-icon.svg",
          engTitle: "\nArabic Priority",
          arabTitle: "الأولوية للعربي",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 25: {
      document = <MyDocument25 arabChunks={arabChunks} engChunks={engChunks} />;

      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/rotate_180.svg",
          engTitle: "\nRotate 180",
          arabTitle: "تدوير 180",
        },
        {
          icon: "/icons/latin-icon.svg",
          engTitle: "\nLatin Priority",
          arabTitle: "الأولوية لللاتيني",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 26: {
      document = <MyDocument26 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/flip_horizontal.svg",
          engTitle: "\nFlip Horizontal",
          arabTitle: "عكس أفقي",
        },
        {
          icon: "/icons/cross.svg",
          engTitle: "\nCross",
          arabTitle: "نصوص عابرة",
        },
      ];
      break;
    }
    case 27: {
      document = <MyDocument27 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/mixed.svg",
          engTitle: "\nMixed",
          arabTitle: "متداخلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
      ];
      break;
    }
    case 28: {
      document = <MyDocument28 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/flip_horizontal.svg",
          engTitle: "\nFlip Horizontal",
          arabTitle: "عكس أفقي",
        },
        {
          icon: "/icons/arabic-icon.svg",
          engTitle: "\nArabic Priority",
          arabTitle: "الأولوية للعربي",
        },
      ];
      break;
    }
    case 29: {
      document = <MyDocument29 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/flip_horizontal.svg",
          engTitle: "\nFlip Horizontal",
          arabTitle: "عكس أفقي",
        },
        {
          icon: "/icons/latin-icon.svg",
          engTitle: "\nLatin Priority",
          arabTitle: "الأولوية لللاتيني",
        },
        {
          icon: "/icons/structure_icon_01.svg",
          engTitle: "\nTwo Books in One",
          arabTitle: "كتابين في كتاب",
        },
      ];
      break;
    }
    case 30: {
      document = <MyDocument30 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/flip_horizontal.svg",
          engTitle: "\nFlip Horizontal",
          arabTitle: "عكس أفقي",
        },
      ];
      break;
    }
    case 31: {
      document = <MyDocument31 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/arabic-icon.svg",
          engTitle: "\nArabic Priority",
          arabTitle: "الأولوية للعربي",
        },
      ];
      break;
    }
    case 32: {
      document = <MyDocument32 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/latin-icon.svg",
          engTitle: "\nLatin Priority",
          arabTitle: "الأولوية لللاتيني",
        },
      ];
      break;
    }
    case 33: {
      document = <MyDocument33 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/arabic-icon.svg",
          engTitle: "\nArabic Priority",
          arabTitle: "الأولوية للعربي",
        },
      ];
      break;
    }
    case 34: {
      document = <MyDocument34 arabChunks={arabChunks} engChunks={engChunks} />;
      resultsFilters = [
        {
          icon: "/icons/separate1.svg",
          engTitle: "\nSeparate",
          arabTitle: "منفصلة",
        },
        {
          icon: "/icons/donot_flip.svg",
          engTitle: "\nDo Not Flip",
          arabTitle: "لا إنعكاس",
        },
        {
          icon: "/icons/parallel.svg",
          engTitle: "\nParallel",
          arabTitle: "نصوص متوازية",
        },
        {
          icon: "/icons/latin-icon.svg",
          engTitle: "\nLatin Priority",
          arabTitle: "الأولوية لللاتيني",
        },
      ];
      break;
    }
    default:
      break;
  }
  return [document, resultsFilters];
};

export const handleArabicPunctuation = (word) => {
  // Match guillemets, quotation marks, and parentheses
  const regex = /([\u00AB\u00BB"()'”“])/g;
  // Break the string into an array
  const result = word.split(regex).filter((item) => item !== "");
  const replacedArray = result.map((item) => {
    switch (item) {
      case "(":
        return ")";
      case ")":
        return "(";
      case "\u00AB":
        return "\u00BB"; // Guillemets
      case "\u00BB":
        return "\u00AB"; // Guillemets
      case "”":
        return "“";
      case "“":
        return "”";
      default:
        return item;
    }
  });
  return replacedArray;
};
